<template>
  <div :class="$style.contentWrapper">
    <div :class="$style.textContent">
      <BaseLabel color="success" mb>
        {{
          t('subscription.cancelation_flow.offer.savings_label', {
            amount: filters.currency(
              basePrice?.amountSubtotal ?? 0,
              basePrice?.currency ?? ''
            ),
            period: translatedPeriod
          })
        }}
      </BaseLabel>
      <BaseHeading :class="$style.offerHeading" mb>
        {{ t('subscription.cancelation_flow.offer.heading') }}
      </BaseHeading>
      <BaseText mb>
        {{ t('subscription.cancelation_flow.offer.description') }}
      </BaseText>
    </div>
    <div :class="$style.imageContainer">
      <img
        src="/img/cancel-subscription/treatwell_offer.svg"
        alt="Treatwell marketplace offer illustration"
        :class="$style.offerImage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useCurrentPlanQuote } from '../../store';
import filters from '../../../../../filters';

const { t } = useI18n();
const currentPlanQuoteStore = useCurrentPlanQuote();
const { quote, basePrice } = storeToRefs(currentPlanQuoteStore);

const translatedPeriod = computed(() => {
  if (!quote.value?.period) return '';
  return t(`global.items.${quote.value.period.toLowerCase()}`);
});
</script>

<style lang="scss" module>
.contentWrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  gap: $spacing;
}

.textContent {
  flex: 1; // Allow text content to take available space
}

.imageContainer {
  width: 190.293px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.offerImage {
  display: block;
  max-width: 100%;
  height: auto;
}
</style> 
